import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { gql } from 'apollo-angular';
import { QueryManagerService } from 'projects/box-lib/src/lib/services/queryManagerService';
import { SendEmailFromOperationsInput } from 'projects/box-lib/src/lib/models/generated/graphql';
const SENDMAILFOROPERATIONS = gql`
  mutation sendEmailToConsultant($input: SendEmailFromOperationsInput!) {
    sendEmailToConsultant(input: $input)
  }
`;
@Component({
    selector: 'app-notify-mail-consultant',
    templateUrl: './notify-mail-consultant.component.html',
    styleUrls: ['./notify-mail-consultant.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotifyMailConsultantComponent {
  mailFromControl: FormControl<string | null>;
  subjectControl: FormControl<string | null>;
  messageControl: FormControl<string | null>;
  isSending: boolean = false;

  constructor(
    private queryManager: QueryManagerService,
    private dialogRef: MatDialogRef<NotifyMailConsultantComponent>,
    @Inject(MAT_DIALOG_DATA)
    protected data: {
      operationIds: number[];
    }
  ) {
    this.mailFromControl = new FormControl('no-reply@stellium.com');
    this.mailFromControl.disable();
    this.subjectControl = new FormControl('', [Validators.required]);
    this.messageControl = new FormControl('', [Validators.required]);
  }

  onSendEmailClick() {
    if (this.isSending) return;
    const input: SendEmailFromOperationsInput = {
      operationIds: this.data.operationIds,
      subject: this.subjectControl.value ?? '',
      message: this.messageControl.value ?? '',
    };
    this.isSending = true;
    this.queryManager
      .mutate({
        mutation: SENDMAILFOROPERATIONS,
        variables: {
          input,
        },
      })
      .subscribe(() => {
        this.isSending = false;
        this.dialogRef.close(true);
      });
  }
}
